import * as iotAPI from '../api/iot'

// IoT Device Management
export const getIoTDevices = iotAPI.getIoTDevices
export const registerIoTDevice = iotAPI.registerIoTDevice
export const removeIoTDevice = iotAPI.removeIoTDevice

// Token Management
export const getTokenStatus = iotAPI.getTokenStatus
export const extendToken = iotAPI.extendToken
export const getExpiredTokens = iotAPI.getExpiredTokens

// Default export for React Admin integration
export default {
  getIoTDevices,
  registerIoTDevice,
  removeIoTDevice,
  getTokenStatus,
  extendToken,
  getExpiredTokens
}
